import { Component, Host, h, Prop } from '@stencil/core';

@Component({
  tag: 'legrandav-link',
  styleUrl: 'legrandav-link.css',
  shadow: true,
})
export class LegrandavLink {

  @Prop() label: string;
  @Prop() color: string;
  @Prop() size: string;
  @Prop() linkOnClick: Function;

  render() {
    return (
      <Host>
        <span>
          <a href="javascript:void(0);" 
             class="signin-link" 
             style={{fontSize: this.size, color: this.color}}>{this.label}</a>
        </span>
      </Host>
    );
  }

}
